<template>
    <div class="order-evaluate">
        <div class="evaluate-container">
            <div class="top">
                <div class="title">评价宝贝</div>
                <div class="shop-name">
                    <div class="label">店铺:</div>
                    <div class="name">{{detail.shop_name}}</div>
                    <img src="@/assets/images/icon-mall-cart-service.png"  @click="showChat(detail.shop.designer_info)" alt="" class="chat-icon">
                </div>
            </div>
            <div class="body">
                <div class="body-container" v-for="(item,index) in form" :key="index">
                    <div class="product-info">
                        <img :src="item.image|default_img" alt="" class="product-img" />
                        <div class="product-name">{{item.product_name}}</div>
                        <div class="product-spec">{{item.spec_name}}</div>
                    </div>
                    <div class="body-right">
                        <textarea placeholder="请输入评价内容" class="evaluate-content" v-model="item.content"></textarea>
                        <div class="upload-container">
                            <div class="upload-item" v-for="(img,img_index) in item.image_list" :key="img_index">
                                <template>
                                    <img v-viewer v-if="!util.is_video(img.raw_name)" :src="img.raw | default_img" alt="" />
                                    <img v-else :src="`${img.raw}?x-oss-process=video/snapshot,t_1000,m_fast`" @click="onPreviewVideo(img.raw)" style="cursor:pointer;" />
                                </template>
                                <img v-if="util.is_video(img.raw)" src="@/assets/images/icon-mall-play.png" alt="" class="video-play" @click="onPreviewVideo(img.raw)" style="cursor:pointer;" />
                                <div class="delete-btn" @click.stop="onDeleteImg(index,img_index)">删除</div>
                            </div>
                            <Upload
                                action="/"
                                :data="{ dir: 'template' }"
                                multiple
                                :before-upload="(file)=>onBeforeUpload(file,index)"
                                :show-upload-list="false"
                            >
                                <div class="upload-btn">
                                    <img src="@/assets/images/icon-upload.png" alt="" class="upload-icon" />
                                    <div class="upload-text">上传图片</div>
                                </div>
                            </Upload>
                            <div class="upload-tips">共<span>{{item.image_list.length || 0}}</span>张,还能上传{{5-item.image_list.length}}张</div>
                        </div>
                        <div class="rating-box">
                            <div class="rating-container">
                                <div class="rating-label">宝贝与描述相符</div>
                                <div class="stars">
                                    <span
                                        v-for="n in 5"
                                        :key="n"
                                        class="star-item"
                                        @click="setRating(n,index,'description_rating')"
                                        @mouseover="hoverStar(index,n,'description_hover_rating')"
                                        @mouseleave="unhoverStar(index,0,'description_hover_rating')"
                                    >
                                        <img
                                            :src="getStarImage(index,'description',n)"
                                            :alt="`star-${n}`"
                                            class="star-icon"
                                        />
                                    </span>
                                    <div class="score">{{(item.description_rating || item.description_hover_rating) | rating_filter}}</div>
                                </div>
                            </div>
                            <div class="rating-container">
                                <div class="rating-label">卖家的服务态度</div>
                                <div class="stars">
                                    <span
                                        v-for="n in 5"
                                        :key="n"
                                        class="star-item"
                                        @click="setRating(n,index,'service_rating')"
                                        @mouseover="hoverStar(index,n,'service_hover_rating')"
                                        @mouseleave="unhoverStar(index,0,'service_hover_rating')"
                                    >
                                        <img
                                            :src="getStarImage(index,'service',n)"
                                            :alt="`star-${n}`"
                                            class="star-icon"
                                        />
                                    </span>
                                    <div class="score">{{(item.service_rating || item.service_hover_rating) | rating_filter}}</div>
                                </div>
                            </div>
                            <div class="rating-container">
                                <div class="rating-label">物流服务的质量</div>
                                <div class="stars">
                                    <span
                                        v-for="n in 5"
                                        :key="n"
                                        class="star-item"
                                        @click="setRating(n,index,'logistics_rating')"
                                        @mouseover="hoverStar(index,n,'logistics_hover_rating')"
                                        @mouseleave="unhoverStar(index,0,'logistics_hover_rating')"
                                    >
                                        <img
                                            :src="getStarImage(index,'logistics',n)"
                                            :alt="`star-${n}`"
                                            class="star-icon"
                                        />
                                    </span>
                                    <div class="score">{{(item.logistics_rating || item.logistics_hover_rating) | rating_filter}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submit-box">
                    <div class="submit-btn" @click="onSubmitComment">发表评论</div>
                </div>
            </div>
        </div>
         <Chat ref="chat"></Chat>
         <!-- 视频预览弹窗 -->
         <div v-if="show_video_preview" class="video-preview-mask" @click="closeVideoPreview">
             <div class="video-preview-container" @click.stop>
                 <div class="video-preview-close" @click="closeVideoPreview">×</div>
                 <video :src="preview_video_url" controls autoplay class="video-preview"></video>
             </div>
         </div>
    </div>
</template>
<script>
import { MallComment, MallOrderDetail } from '@/api/index';
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
export default{
    data(){
        return{
            uuid:'',
            util,
            uploading: false,
            uploadQueue:[],
            debounceTimer: null, // 防抖定时器
            debounceTime: 300, // 防抖时间（毫秒）
            form:[],
            curr_upload_index:'',
            detail: {},
            show_video_preview: false,
            preview_video_url: ''
        }
    },
    filters:{
        rating_filter(value){
            switch(Number(value)){
                case 1:
                    return '1分 很差';
                case 2:
                    return '2分 不满意';
                case 3:
                    return '3分 一般';
                case 4:
                    return '4分 满意';
                case 5:
                    return '5分 很满意';
                default:
                    return '';
            }
        }
    },
    mounted(){
        const {uuid} = this.$route.query;
        if(!uuid){
            this.$layer.msg('参数异常[id]');
            return;
        }
        this.uuid = uuid;
        this.onOrderDetail();
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            // 通过 `vm` 访问组件实例
            vm.$emit("changeFooter", "mall");
        });
    },
    methods:{
        showChat(user) {
            console.log(user)
            this.$refs["chat"].showChat(user);
        },
        onDeleteImg(parentIndex,subIndex){
            this.form[parentIndex].image_list.splice(subIndex,1);
        },
        async onSubmitComment(){
            try{
                const {uuid,form} = this;
                const param = {};
                param.order_uuid = uuid;
                param.comment_data = form;
                console.log('this.form',param);
                const {code,msg} = await MallComment(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('感谢您的评价~');
                this.$router.replace({name:'MallOrderCenter'});
            }catch(e){
                console.log('err-submit-comment',e);
                this.$layer.msg(e.msg);
            }
        },
        async onOrderDetail(){
            try{
                const {uuid} = this;
                const {code,msg,data} = await MallOrderDetail({uuid})
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data',data);
                this.detail = data
                const {goods,shop} = data;
                if(!goods.length){
                    this.$layer.msg('获取评价商品失败[goods_empty]');
                    return;
                }
                this.form = goods.map((item)=>{
                    return {
                        og_uuid:item.uuid,
                        spec_name:item.spec_info,
                        product_name:item.product_name,
                        image:item.product_image,
                        content:'',
                        image_list:[],
                        description_rating:0,
                        description_hover_rating:0,
                        service_rating:0,
                        service_hover_rating:0,
                        logistics_rating:0,
                        logistics_hover_rating:0
                    }
                })
                console.log('form===>',this.form);
            }catch(e){
                console.log('err-on-get-detail',e);
                this.$layer.msg(e.msg);
            }
        },
        async processAllFiles() {
            const queue = [...this.uploadQueue];
            this.uploadQueue = []; // 清空队列
            const index = this.curr_upload_index;

            if(this.uploadQueue.length > 5 || this.form[index].image_list.length >= 5 || (this.form[index].image_list.length+this.uploadQueue.length)>5){
                this.$layer.msg("商品图片最多只能上传5张图片/视频");
                return;
            }

            console.log(`Startting upload ${queue.length} files...`);

            for (const file of queue) {
                try {
                    const url = await uploadFileToOSS(file, "template");
                    const object = {raw:url,raw_name:file.name,type:util.is_video(url) ? 'video':'image'};
                    this.form[index].image_list.push(object);
                    console.log('image_list',this.form[index].image_list);
                } catch (err) {
                    console.error('err',err);
                    this.$layer.msg(`上传失败：${file.name}`);
                }
            }

        },
        onBeforeUpload(file,index) {
            this.curr_upload_index = index;
            console.log("file-before", file);
            this.uploading = true;
            // 将文件加入队列
            this.uploadQueue.push(file);

            // 清除旧定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
            this.debounceTimer = setTimeout(() => {
                this.processAllFiles();
            }, this.debounceTime);
            return false;
        },
        //>设置评分
        setRating(rating,index,field) {
            this.$set(this.form[index],field,rating);
        },

        //>悬停在星星上
        hoverStar(index,rating,field) {
            this.$set(this.form[index],field,rating);
        },

        //>移开悬停
        unhoverStar(index,rating,field) {
            this.$set(this.form[index],field,0);
        },

        //>获取星星图标
        getStarImage(index,field,rating) {
            //>如果悬停评分大于0，使用悬停评分，否则使用实际评分
            const currentRating = this.form[index][`${field}_hover_rating`] > 0 ? this.form[index][`${field}_hover_rating`] : this.form[index][`${field}_rating`];


            if (rating <= currentRating) {
                //>根据评分选择不同的图标
                if (currentRating <= 2) {
                    //>1-2星使用不喜欢图标
                    return require('@/assets/images/icon-mall-star-unlike.png');
                } else {
                    //>2星以上使用喜欢图标
                    return require('@/assets/images/icon-mall-star-like.png');
                }
            } else {
                //>空星图标
                return require('@/assets/images/icon-mall-star-empty.png');
            }
        },
        //>视频预览
        onPreviewVideo(url) {
            this.preview_video_url = url;
            this.show_video_preview = true;
        },
        closeVideoPreview() {
            this.show_video_preview = false;
            this.preview_video_url = '';
        }
    }
}
</script>
<style lang="scss" scoped>
.order-evaluate{
    width:100%;
    min-height:calc(100vh - 80px - 420px);
    background:#f9fafb;
    display:flex;
    justify-content:center;
    .evaluate-container{
        width:1000px;
        display:flex;
        flex-direction:column;
        margin-top:29px;
        .top{
            width:100%;
            display:flex;
            justify-content:space-between;
            align-items:baseline;
            .title{
                font-size:24px;
                color:#333333;
                font-weight:500;
            }
            .shop-name{
                display:flex;
                align-items:center;
                font-size:15px;
                .label{
                    color:#666666;
                }
                .name{
                    color:#4f93e0;
                    margin-right:16px;
                }
                .chat-icon{
                    width:24px;
                    height:24px;
                    cursor:pointer;
                }
            }
        }
        .body{
            width:100%;
            background:#ffffff;
            border-radius:10px;
            margin-top:14px;
            .body-container{
                width:100%;
                padding:0 50px;
                display:flex;
                align-items:start;
                column-gap:40px;
                margin-top:37px;
                .product-info{
                    width:200px;
                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    .product-img{
                        width:100%;
                        height:200px;
                        border-radius:10px;
                        border:1px solid #d1d5db;
                        object-fit:cover;
                    }
                    .product-name{
                        margin-top:8px;
                        color:#333333;
                        font-size:14px;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        text-align:center;
                    }
                    .product-spec{
                        margin-top:4px;
                        color:#666666;
                        font-size:12px;
                    }
                }
                .body-right{
                    flex:1;
                    display:flex;
                    flex-direction:column;
                    textarea{
                        width:100%;
                        height:200px;
                        border-radius:8px;
                        border:1px solid #d1d5db;
                        outline:none;
                        padding:10px;
                    }
                    .upload-container{
                        display:flex;
                        align-items:center;
                        column-gap:10px;
                        margin-top:16px;
                        .upload-btn{
                            width:52px;
                            height:52px;
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            flex-direction:column;
                            background:#f7f7f7;
                            border:1px solid #eeeeee;
                            border-radius:4px;
                            cursor:pointer;
                            .upload-icon{
                                width:22px;
                                height:18px;
                            }
                            .upload-text{
                                color:#999999;
                                font-size:10px;
                                margin-top:7px;
                            }
                        }
                        .upload-tips{
                            font-size:12px;
                            color:#999999;
                            span{
                                color:#ff5967;
                            }
                        }
                        .upload-item{
                            width:52px;
                            height:52px;
                            border:1px solid #eeeeee;
                            border-radius:4px;
                            position:relative;
                            cursor:pointer;
                            img{
                                width:100%;
                                height:100%;
                                border-radius:4px;
                                z-index:2;
                            }
                            .play-icon{
                                position:absolute;
                                top:50%;
                                left:50%;
                                transform: translate(-50%,-50%);
                                width:21px;
                                height:21px;
                                z-index:9;
                            }
                            .video-play{
                                position:absolute;
                                top:2px;
                                right:2px;
                                width:16px;
                                height:16px;
                                z-index:9;
                            }
                            .delete-btn{
                                width:100%;
                                height:16px;
                                // height:100%;
                                border-radius:0 0 4px 4px;
                                background:rgba(0,0,0,0.72);
                                color:#ffffff;
                                font-size:14px;
                                text-align:center;
                                line-height:16px;
                                position:absolute;
                                left:0;
                                bottom:0;
                                z-index:10;
                                display:none;
                            }
                            &:hover{
                                .delete-btn{
                                    display:inline-block;
                                }
                            }
                        }
                    }
                    .rating-box{
                        display:flex;
                        flex-direction:column;
                        margin-top:40px;
                        .rating-container {
                            margin-bottom: 20px;
                            display:flex;
                            align-items:center;
                            column-gap:8px;
                            .rating-label {
                                margin-bottom: 10px;
                                font-size: 14px;
                                color: #333333;
                                font-weight: 500;
                            }

                            .stars {
                                display: flex;
                                align-items: center;
                                column-gap: 8px;

                                .star-item {
                                    cursor: pointer;

                                    .star-icon {
                                        width: 30px;
                                        height: 30px;
                                    }
                                }
                                .score{
                                    color:#ff5967;
                                    font-size:13px;
                                }
                            }
                        }
                    }

                }
            }
            .submit-box{
                width:100%;
                border-top:1px solid #e5e7eb;
                display:flex;
                align-items:center;
                justify-content:center;
                padding-top:40px;
                padding-bottom:67px;
                .submit-btn{
                    cursor:pointer;
                    width:230px;
                    height:48px;
                    line-height:48px;
                    text-align:center;
                    color:#ffffff;
                    border-radius:10px;
                    background:#ff5967;
                    font-size:16px;
                }
            }
        }

    }
}
// 视频预览弹窗样式
.video-preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    .video-preview-container {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
        .video-preview-close {
            position: fixed;
            top: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            color: #333;
            cursor: pointer;
            z-index: 1000000;
            &:hover {
                background: #fff;
            }
        }
        .video-preview {
            max-width: 90vw;
            max-height: 90vh;
            width: auto;
            height: auto;
            object-fit: contain;
            border-radius: 4px;
        }
    }
}
</style>
